// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalInventoryLogs_root__tVR9b","log":"ModalInventoryLogs_log__F8PEL","date":"ModalInventoryLogs_date__2uHOs","userName":"ModalInventoryLogs_userName__1qCAk"};